import { createContext } from "react";
import { useState, useEffect } from "react";
import {
  getAllTaskRequest,
  postTaskRequest,
  deleteTaskRequest,
  putTaskRequest,
} from "../api/task.api";
export const TaskContext = createContext();
export const TaskContextProvider = ({ children }) => {
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(false);

  const getTasks = async () => {
    const res = await getAllTaskRequest();
    setTasks(res.data);
  };

  useEffect(() => {
    setLoading(true);
    getTasks();
    setLoading(false);
  }, []);

  const insertTask = async (task) => {
    await postTaskRequest(task);
    getTasks();
  };

  const deleteTask = async (id) => {
    await deleteTaskRequest(id);
    getTasks();
  };
  const putTask = async (id, done) => {
    await putTaskRequest(id, {done : done ? "false" : "true"});
    getTasks();
  };

  const data = {
    loading,
    tasks,
    insertTask,
    deleteTask,
    putTask,
  };
  return <TaskContext.Provider value={data}>{children}</TaskContext.Provider>;
};
